define('ui/dfn-list',["exports", "core/ui", "core/l10n", "deps/hyperhtml"], function (exports, _ui, _l10n) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.show = undefined;


  const button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].definition_list, "ui/dfn-list", "Ctrl+Shift+Alt+D", "📔"); /// Module ui/dfn-list
  // Displays all definitions with links to the defining element.


  const ul = document.createElement("ul");
  ul.classList.add("respec-dfn-list");
  const render = window.hyperHTML.bind(ul);

  ul.addEventListener("click", ev => {
    _ui.ui.closeModal();
    ev.stopPropagation();
  });

  function show() {
    const definitionLinks = Object.entries(respecConfig.definitionMap).sort(([keyA], [keyB]) => keyA.localeCompare(keyB)).map(([, $dfns]) => {
      const [dfn] = $dfns[0];
      return window.hyperHTML.wire(dfn, ":li>a")`
        <li>
          <a href="${"#" + dfn.id}">
            ${dfn.textContent}
          </a>
        </li>
      `;
    });
    render`${definitionLinks}`;
    _ui.ui.freshModal(_l10n.l10n[_l10n.lang].list_of_definitions, ul, button);
  }

  exports.show = show;
});
//# sourceMappingURL=dfn-list.js.map;
